if (!customElements.get('pdp-sticky-purchase')) {
  customElements.define(
    'pdp-sticky-purchase',
    class PdpStickyPurchase extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 989px)');
        this.productInfo = document.querySelector(`#ProductInfo-${this.dataset.sectionId}`);
        this.purchaseRow = this.productInfo?.querySelector('.pdp-composition__purchase');
        this.productRegion = this.productInfo?.querySelector('.product');
        this.reviews = document.querySelector('main .app-disclosure');
        this.menuDrawer = document.querySelector('.ecosystem-drawer .menu-drawer-container');
        this.stickySubmit = this.querySelector('[data-sticky-action="submit"]');

        if (!this.purchaseRow || !this.stickySubmit) {
          return;
        }

        this.onStickyClick = this.onStickyClick.bind(this);
        this.onMediaChange = this.updateVisibility.bind(this);
        this.onMenuToggle = this.updateVisibility.bind(this);

        this.addEventListener('click', this.onStickyClick);
        this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.menuDrawer?.addEventListener('toggle', this.onMenuToggle);
        this.bindSourceControls();

        if (this.productRegion) {
          this.regionObserver = new IntersectionObserver(([entry]) => {
            this.productRegionVisible = entry.isIntersecting;
            this.updateVisibility();
          });
          this.regionObserver.observe(this.productRegion);
        } else {
          this.productRegionVisible = true;
        }

        if (this.reviews) {
          this.reviewsObserver = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) this.hasReachedReviews = true;
            this.updateVisibility();
          });
          this.reviewsObserver.observe(this.reviews);
        } else {
          this.reviewsVisible = false;
        }

        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onStickyClick);
        this.mediaQuery?.removeEventListener('change', this.onMediaChange);
        this.menuDrawer?.removeEventListener('toggle', this.onMenuToggle);
        this.sourceObserver?.disconnect();
        this.regionObserver?.disconnect();
        this.reviewsObserver?.disconnect();
      }

      bindSourceControls() {
        this.sourceSubmit = this.purchaseRow.querySelector('.product-form__submit');
        this.sourceError = this.purchaseRow.querySelector('.product-form__error-message-wrapper');

        this.sourceObserver = new MutationObserver(() => this.sync());
        [this.sourceSubmit, this.sourceError].filter(Boolean).forEach((element) => {
          this.sourceObserver.observe(element, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true,
          });
        });
      }

      onStickyClick(event) {
        const action = event.target.closest('[data-sticky-action]')?.dataset.stickyAction;
        if (!action) return;

        if (action === 'submit' && !this.sourceSubmit?.disabled && this.sourceSubmit?.getAttribute('aria-disabled') !== 'true') {
          this.sourceSubmit.click();
        }

        requestAnimationFrame(() => this.sync());
      }

      sync() {
        if (!this.sourceSubmit) return;
        this.stickySubmit.disabled = this.sourceSubmit.disabled;
        this.stickySubmit.toggleAttribute('aria-disabled', this.sourceSubmit.getAttribute('aria-disabled') === 'true');
        this.stickySubmit.classList.toggle('loading', this.sourceSubmit.classList.contains('loading'));

        const sourceText = this.sourceSubmit.querySelector('span:not(.loading__spinner)');
        const stickyText = this.stickySubmit.querySelector('span:not(.loading__spinner)');
        if (sourceText && stickyText) stickyText.textContent = sourceText.textContent;

        const stickySpinner = this.stickySubmit.querySelector('.loading__spinner');
        const sourceSpinner = this.sourceSubmit.querySelector('.loading__spinner');
        stickySpinner?.classList.toggle('hidden', sourceSpinner?.classList.contains('hidden') ?? true);
      }

      updateVisibility() {
        const shouldShow =
          this.mediaQuery.matches && this.productRegionVisible && !this.hasReachedReviews && !this.menuDrawer?.open;
        this.hidden = !shouldShow;
      }
    }
  );
}
